var getOrigin = function getOrigin(href) {
    if (!window.location.origin) {
        return window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    } else {
        return window.location.origin;
    }
}

exports.getOrigin = getOrigin;
